'use strict'

import React from 'react'
import { translate } from 'react-i18next'
import CircularProgress from '@material-ui/core/CircularProgress'
import { sendPasswordResetEmail } from './../helpers/firebase'
import { AvForm } from 'availity-reactstrap-validation'
import AvCustomInput from './AvCustomInput'
import { Button } from 'reactstrap'
import ModalSuccess from './ModalSuccess'

class LostPasswordForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      success: '',
      error: '',
      pending: false
    }
  }

  handleSubmit(values) {
    const { t } = this.props
    const { email } = values

    this.setState({ pending: true, error: false, success: '' })

    sendPasswordResetEmail(email)
      .then(() => this.setState({
        success: t('FIREBASE_PASSWORD_FORGOT_SENT'),
        error: '',
        pending: false
      }))
      .catch(err => {
        console.log(err)
        this.setState({
          success: '',
          error: t('ERROR'),
          pending: false
        })
      })
  }

  render() {
    const { success, error, pending } = this.state
    const { t } = this.props

    return (
      <div className="cont-login">
        <div className="row">
          <div className="col-sm-12 no-border">
            <h2 className="u-text-center">{t('FORGOT_PASSWORD_TITLE')}</h2>
            <p
              className="u-text-center"
              dangerouslySetInnerHTML={{ __html: t('FORGOT_PASSWORD_SUBTITLE') }}
            />

            <AvForm onValidSubmit={(event, values) => this.handleSubmit(values)}>
              <AvCustomInput
                name="email"
                type="email"
                validate={{ email: true }}
                required={true}
                error={t('FORM_VALID_EMAIL')}
                label={t('EMAIL')}
              />
              {
                pending ?
                  <div className="row spinner-container">
                    <CircularProgress className="spinner" />
                  </div>
                  :
                  <Button>{t('FORGOT_BTN_SUBMIT')}</Button>
              }
            </AvForm>
            {
              error && <p className="text-center mt-3 form-input-error">{error}</p>
            }
            <ModalSuccess
              open={success}
              message={success}
              toggle={() => this.setState({ success: '' })}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default translate(['common'])(LostPasswordForm)


// WEBPACK FOOTER //
// src/components/LostPasswordForm.js